<template>
  <div class="service-margin">
    <div class="row">
      <div class="col-sm-6"> </div>
      <div class="col-sm-6">
        <div class="form-group has-search ">
          <span class="fa fa-search form-control-feedback"></span>
          <input
            v-model="SearchKeyword"
            type="text"
            class="form-control"
            placeholder="Search"
            @keyup.enter="getserviceListForMargin(0, 0)"
          />
        </div> </div
    ></div>
    <div>
      <DxDataGrid
        ref="serviceMarginDataGrid"
        :data-source="serviceListForMargin"
        :show-borders="true"
        :hover-state-enabled="true"
        :remote-operations="false"
        :allow-column-reordering="true"
        :row-alternation-enabled="false"
        :column-hiding-enabled="true"
        key-expr="ServiceRequestFormId"
        :show-column-lines="true"
        :show-row-lines="true"
        @optionChanged="isLastPage"
      >
        <DxGroupPanel :visible="true" />
        <DxSearchPanel :visible="false" :highlight-case-sensitive="true" />
        <DxGrouping :auto-expand-all="true" />

        <DxPager
          :allowed-page-sizes="[5, 10, 20]"
          :show-page-size-selector="true"
          :show-info="true"
          :show-navigation-buttons="true"
        />
        <DxPaging :page-size="20" />
        <DxColumn
          data-field="ProviderName"
          caption="Vendor Name"
          cell-template="vendorNameTemplate"
          :allow-sorting="true"
          :width="230"
        />
        <div slot="vendorNameTemplate" slot-scope="{ data }">
          <h6> {{ data.ProviderName }} </h6>
        </div>
        <DxColumn
          data-field="ServiceRequestFormName"
          caption="Service Name"
          cell-template="ServiceRequestFormTemplate"
          :allow-sorting="true"
          alignment="left"
          :width="230"
        />
        <div slot="ServiceRequestFormTemplate" slot-scope="{ data }">
          <h6>
            {{ data.ServiceRequestFormName }}
          </h6>
        </div>
        <DxColumn
          data-field="Distribution"
          caption="Distribution"
          cell-template="vendorStatusTemplate"
          :allow-sorting="true"
          alignment="center"
          :width="230"
        />
        <div slot="vendorStatusTemplate" slot-scope="{ data }">
          <h6>
            {{ data.Distribution }}
          </h6>
        </div>
        <DxColumn
          data-field="MarginType"
          caption="Margin Type"
          cell-template="paymentTypeTemplate"
          :allow-sorting="true"
          alignment="left"
          :width="200"
        />
        <div slot="paymentTypeTemplate" slot-scope="{ data }">
          <div class="cursor-pointer vendor-enquiry-display">
            <a class="cursor-pointer mr-l0 mr-3  display-mr-b10">
              <DxSelectBox
                v-model:value="data.MarginType"
                :data-source="marginStatusdata"
                @value-changed="setMarginType(data)"
              />
            </a>
          </div>
        </div>
        <DxColumn
          data-field="Value"
          caption="Set Margin"
          :allow-sorting="false"
          :allow-grouping="false"
          cell-template="actionTemplate"
          :allow-header-filtering="false"
          alignment="left"
        />

        <div slot="actionTemplate" slot-scope="{ data }">
          <div class="cursor-pointer ">
            <div class="form-inline form-group" style="max-width:160px">
              <div
                v-if="data.MarginType == 'Fixed' || data.MarginType == 'Both'"
              >
                <div class="input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text">$</span>
                  </div>

                  <input
                    id="fixedMargin"
                    v-model="data.FixedMargin"
                    type="text"
                    class="form-control text-right"
                    maxlength="10"
                    placeholder=""
                    @keyup="changeInFixedMargin(data)"
                  />
                </div>
              </div>
              <div
                ><span
                  v-if="marginError === data.ServiceRequestFormId"
                  class="color-red"
                  >Invalid fixed cost margin</span
                ></div
              >
              <div
                v-if="
                  data.MarginType == 'Percentage' || data.MarginType == 'Both'
                "
              >
                <div
                  class="input-group "
                  :class="{
                    'mr-t20': data.MarginType == 'Both' ? true : false,
                  }"
                >
                  <div class="input-group-prepend  ">
                    <span class="input-group-text">%</span>
                  </div>

                  <input
                    id="exampleInputAmount"
                    v-model:value="data.PercentMargin"
                    type="number"
                    class="form-control text-right"
                    placeholder=""
                    @input="changeInMargin(data)"
                  />
                </div>
              </div>
              <div
                ><span
                  v-if="errorId === data.ServiceRequestFormId"
                  class="color-red"
                  >The maximum percentage cannot be more than 20% & less than
                  0%</span
                ></div
              >
            </div>
          </div>
        </div>

        <DxSearchPanel :visible="false" :highlight-case-sensitive="true" />
      </DxDataGrid>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="displayflex mr-t50 mb-4  ">
          <div class="wd-20 mr-2">
            <button
              type="button"
              class="btn btn f-w-red-btn save-btn-width"
              @click="submitDetails"
            >
              Save
            </button>
          </div>
          <div class="wd-20"> </div>&nbsp;&nbsp;
          <div class="wd-20 mr-2 ">
            <button
              type="button"
              class="btn trans-btn full-width"
              @click="getserviceListForMargin(0, 0)"
            >
              Reset Values
            </button>
          </div>
          <div
            ><span v-if="error" class="color-red"
              >Plz check the percentage and fixed margin</span
            ></div
          >
        </div>
      </div>
    </div>
    <loader v-if="loading"></loader>
    <popup
      v-if="marginUpdatedFlag"
      :msg="postMessage"
      @response="marginUpdatedFlag = false"
    ></popup>
  </div>
</template>

<script>
import popup from '@views/popup'
import 'devextreme/dist/css/dx.common.css'
import 'devextreme/dist/css/dx.light.compact.css'
import '@/public/css/devExtremeGridCssModified.css'
import { superAdminMethods } from '@state/helpers'
import loader from '@views/loader'
import {
  DxDataGrid,
  DxColumn,
  DxPager,
  DxPaging,
  DxGrouping,
  DxGroupPanel,
  DxSearchPanel,
  // DxStateStoring,
  // DxHeaderFilter,
  // DxFilterRow,
} from 'devextreme-vue/data-grid'
import DxSelectBox from 'devextreme-vue/select-box'

export default {
  components: {
    DxSelectBox,
    DxDataGrid,
    DxColumn,
    DxPager,
    DxPaging,
    DxSearchPanel,
    DxGrouping,
    DxGroupPanel,
    loader,
    popup,
  },
  data() {
    return {
      serviceListForMargin: [],
      marginStatusdata: ['Percentage', 'Fixed', 'Both'],
      loading: false,
      providerId: 0,
      SearchKeyword: '',
      ModificationArray: [],
      postMessage: '',
      marginUpdatedFlag: false,
      changedId: {},
      errorId: 0,
      marginError: 0,
      error: false,
    }
  },

  created() {
    this.getserviceListForMargin(0, 0)
  },
  destroyed() {
    this.$emit('resetProviderId', 0)
  },
  methods: {
    ...superAdminMethods,

    // -------------------------------------------------------------------------------------------------------
    // Get list of all Service List
    async getserviceListForMargin(countValue, next = 0) {
      try {
        this.loading = true

        const responseBLK = await this.getListOfServicesForMargin_BuildingLink({
          ProviderId: 0,
          recordAvailable: countValue,
          searchKeyword: this.SearchKeyword.length ? this.SearchKeyword : '%00',
        })
        if (next) {
          this.serviceListForMargin = this.serviceListForMargin.concat(
            responseBLK
          )
        } else {
          this.changedId = {}
          this.serviceListForMargin = responseBLK
        }

        this.loading = false
        // this.serviceListForMargin = [
        //   {
        //     ServiceRequestFormId: 14,
        //     ProviderName: 'Best Buy',
        //     ServiceRequestFormName: 'Covid Home Service',
        //     Distribution: 155,
        //     MarginType: 'Fixed',
        //     FixedMargin: 10,
        //     PercentMargin: 0,
        //     IsOverrideChild: false,
        //   },
        //   {
        //     ServiceRequestFormId: 16,
        //     ProviderName: 'Best Buy',
        //     ServiceRequestFormName: 'Covid Home Service',
        //     Distribution: 155,
        //     MarginType: 'Fixed',
        //     FixedMargin: 10,
        //     PercentMargin: 0,
        //     IsOverrideChild: false,
        //   },
        // ]
        // this.serviceListForMargin = this.serviceListForMargin.map((obj) => {
        //   obj.modifiedFlag = false
        //   return obj
        // })
        // this.serviceListForMargin = [
        //   {
        //     ProviderName: 'Best Buy',
        //     ServiceRequestFormName: 'Covid Home Service',
        //     Distribution: 155,
        //     providerId: 122,
        //     MarginType: 'Percentage',
        //     marginValue: 10,
        //   }

        // ]

        // this.serviceListForMargin = this.serviceListForMargin.filter((obj) => {
        //   return obj.ProviderName.toLowerCase().includes(
        //     serviceSearchKeyword.toLowerCase()
        //   )
        // })
      } catch (error) {
        this.loading = false
      }
    },
    // -------------------------------------------------------------------------------------------------------
    // Emit Event for the Service Form with filter data
    navigateToServiceTab(data) {
      console.clear()

      console.log(data.providerId)
      let informationObject = {
        tabNumebr: 3,
        providerID: data.providerId,
      }
      this.$emit('openSearchTab', informationObject)
    },
    // -------------------------------------------------------------------------------------------------------
    // Pagination
    isLastPage(pagination) {
      // console.log('isLastPage -> pagination', pagination)
      var currentPage = pagination.value + 1
      var TotalPage = this.$refs['serviceMarginDataGrid'].instance.pageCount()
      // console.log('isLastPage -> currentPage', currentPage)
      var pageIndex =
        this.$refs['serviceMarginDataGrid'].instance.pageIndex() + 1
      if (
        pageIndex === currentPage &&
        currentPage === TotalPage &&
        this.serviceListForMargin.length > 99
      ) {
        console.log('Pagination started working')
        this.getserviceListForMargin(this.serviceListForMargin.length, 1)
      } else if (pagination.fullName === 'paging.pageSize') {
        if (
          typeof pagination.previousValue === 'number' &&
          typeof pagination.value === 'number' &&
          pagination.value > pagination.previousValue &&
          this.serviceListForMargin.length > 99
        ) {
          console.log('Pagination due to page size increment')
          this.getserviceListForMargin(this.serviceListForMargin.length, 1)
        }
      }
    },
    // ------------------------------
    setMarginType(val) {
      this.serviceListForMargin = this.serviceListForMargin.map((obj) => {
        if (obj.ServiceRequestFormId != val.ServiceRequestFormId) return obj
        obj.MarginType = val.MarginType
        return obj
      })
    },
    // ------------------------------
    changeInMargin(val) {
      // this.serviceListForMargin = this.serviceListForMargin.map((obj) => {
      //   if (obj.ServiceRequestFormId != val.ServiceRequestFormId) return obj
      //   obj.modifiedFlag = true
      //   return obj
      // })

      if (val.MarginType == 'Percentage' || val.MarginType == 'Both') {
        if (Number(val.PercentMargin) > 20 || Number(val.PercentMargin) < 0) {
          this.errorId = val.ServiceRequestFormId
          // setTimeout(() => {
          //   this.errorId = 0
          // }, 3000)
        } else {
          this.errorId = 0
        }
      }
      if (!this.changedId[val.ServiceRequestFormId]) {
        this.changedId[val.ServiceRequestFormId] = 1
      }
    },
    changeInFixedMargin(val) {
      if (val.MarginType == 'Fixed' || val.MarginType == 'Both') {
        if (
          (!Number(val.FixedMargin) && Number(val.FixedMargin) != 0) ||
          Number(val.FixedMargin) < 0
        ) {
          this.marginError = val.ServiceRequestFormId

          // setTimeout(() => {
          //   this.marginError = 0
          // }, 3000)
        } else {
          this.marginError = 0
        }
      }

      if (!this.changedId[val.ServiceRequestFormId]) {
        this.changedId[val.ServiceRequestFormId] = 1
      }
    },
    // -------------------------------------------------------------------------------------------------
    async submitDetails() {
      console.clear()

      try {
        this.loading = true
        this.ModificationArray = this.serviceListForMargin.filter((obj) => {
          return !!this.changedId[obj.ServiceRequestFormId]
        })
        let requestBody = this.ModificationArray.map((obj) => {
          let postObject = {
            ServiceRequestFormId: obj.ServiceRequestFormId,
            MarginType: obj.MarginType,
            FixedMargin: Number(obj.FixedMargin) ? Number(obj.FixedMargin) : 0,
            PercentMargin: Number(obj.PercentMargin)
              ? Number(obj.PercentMargin)
              : 0,
            IsOverrideChild: true,
          }
          return postObject
        })

        const idx = this.ModificationArray.findIndex(
          (obj) =>
            !Number(obj.FixedMargin) ||
            Number(obj.FixedMargin) < 0 ||
            Number(obj.PercentMargin) > 20 ||
            Number(obj.PercentMargin) < 0
        )
        if (idx != -1) {
          this.error = true

          setTimeout(() => {
            this.error = false
          }, 5000)
          this.loading = false
        } else {
          await this.setMarginForService({
            ServiceRequestFormMargins: requestBody,
          })
          this.loading = false
          this.postMessage = 'For chosen Service, the margin was set up'
          this.changedId = {}
          this.marginUpdatedFlag = true
        }
      } catch (error) {
        this.loading = false
        this.postMessage = 'Something went wrong please try again !'

        this.marginUpdatedFlag = true
      }
    },
    // -------------------------------------------------------------------------------------------------
    cancelChoice() {
      this.loading = true
      setTimeout(() => {
        this.getserviceListForMargin(0, 0)
        this.loading = false
      }, 3000)
    },
  },
}
</script>

<style scoped>
.service-margin .dx-texteditor.dx-editor-outlined {
  width: 127px !important;
}
</style>
